module.exports = __webpack_public_path__ + "img/download-icon-active.f9b63664.svg";